import axios from 'axios'
import store from '@/store/index.js'

const http = {
  get: async function (url) {
    return new Promise((resolve, reject) => {
      const token = store.getters.getToken
      const headers = {
        Authorization: (token == null) ? '' : token
      }
      axios.get(url, { headers: headers }).then(response => {
        if (response.headers.authorization != null) {
          store.dispatch('update', response.headers.authorization)
        }
        resolve(response)
      }).catch(err => {
        if (err.response.status === 401) {
          store.dispatch('logout')
        }
        reject(err)
      })
    })
  },
  post: async function (url, body) {
    return new Promise((resolve, reject) => {
      const token = store.getters.getToken
      const headers = {
        Authorization: (token == null) ? '' : token
      }
      axios.post(url, body, { headers: headers }).then(response => {
        if (response.headers.authorization != null) {
          store.dispatch('update', response.headers.authorization)
        }
        resolve(response)
      }).catch(err => {
        if (err.response.status === 401) {
          store.dispatch('logout')
        }
        reject(err)
      })
    })
  },
  put: async function (url, body) {
    return new Promise((resolve, reject) => {
      const token = store.getters.getToken
      const headers = {
        Authorization: (token == null) ? '' : token
      }
      axios.put(url, body, { headers: headers }).then(response => {
        if (response.headers.authorization != null) {
          store.dispatch('update', response.headers.authorization)
        }
        resolve(response)
      }).catch(err => {
        if (err.response.status === 401) {
          store.dispatch('logout')
        }
        reject(err)
      })
    })
  },
  delete: async function (url) {
    return new Promise((resolve, reject) => {
      const token = store.getters.getToken
      const headers = {
        Authorization: (token == null) ? '' : token
      }
      axios.delete(url, { headers: headers }).then(response => {
        if (response.headers.authorization != null) {
          store.dispatch('update', response.headers.authorization)
        }
        resolve(response)
      }).catch(err => {
        if (err.response.status === 401) {
          store.dispatch('logout')
        }
        reject(err)
      })
    })
  }
}

export default http
